import React, { useEffect } from "react";
import "./AboutSetting.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import { ArrowRight } from "assets/SVGs/SVGs";
import { useHistory } from "react-router-dom";
import { getStaticUrlByKey } from "utility";
import { useDispatch, useSelector } from "react-redux";
import { getStaticUrls } from "redux/Common/action";

const AboutSetting = () => {
  const { staticUrls } = useSelector((store) => store?.common);
  const userData = useSelector((store) => store?.auth?.userData);
  const history = useHistory();
  const dispatch = useDispatch();

  const aboutOptionsList = [
    {
      id: 0,
      title: titles?.service_and_support,
      type: "service_and_supports",
      url: "https://www.bayalarmmedical.com/customer-service/",
    },
    {
      id: 1,
      title: titles?.faqs,
      type: "faqs",
      url: "https://www.bayalarmmedical.com/frequently-asked-questions/",
    },
    {
      id: 2,
      title: titles?.help_guides,
      type: "help_guides",
      url: "https://www.bayalarmmedical.com/help-guides/",
    },
    {
      id: 3,
      title: titles?.videos,
      type: "videos",
      url: "https://www.bayalarmmedical.com/videos/",
    },
    {
      id: 4,
      title: titles?.privacy_policy,
      type: "privacy_policies",
      url: "https://www.bayalarmmedical.com/privacy-policy/",
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      const params = {
        dispatch,
        userType: userData?.isGuestUser ? "guestuser" : "accountowner",
        history,
      };
      getStaticUrls(params);
    }, 500);
  }, []);

  const onItemPress = async ({ type = "" }) => {
    try {
      const url = getStaticUrlByKey(staticUrls, type);
      window.open(url, "_blank");
    } catch (e) {}
  };

  return (
    <MainLayout
      text={titles?.about}
      isBackHide={false}
      isSemiHeader={true}
      white={false}
    >
      <div>
          <p className="display_h3 text-white-color about_version_text">{titles?.version} 4.5</p>   
        {/* About Options List */}
        {aboutOptionsList?.map((item, index) => {
          return (
            <div key={`about_item_${index}`}>
              <div
                className="settings_item_container"
                onClick={() => onItemPress(item)}
              >
                <div className="settings_item_content">
                  <p className="settings_item_text">{item?.title}</p>
                  <ArrowRight className="settings_chevron_icon" />
                </div>
              </div>
              <div className="settings_separator"></div>
            </div>
          );
        })}
        {/* Copyright Section */}
        <div className="about_copyright_container">
          <p className="display_h5 text-white-color">
            {titles?.bay_alarm_medical}
          </p>
          <p className="display_h5 text-white-color">
            {titles?.all_rights_reserved}
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default AboutSetting;
